export const get = (obj, path = '', defaultValue = undefined) => {
    const travel = regexp =>
        String.prototype.split
            .call(path, regexp)
            .filter(Boolean)
            .reduce((res, key) => (res !== null && res !== undefined ? res[key] : defaultValue), obj);

    const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
    return result === undefined || result === obj ? defaultValue : result;
};

export const isEmpty = obj => [Object, Array].includes((obj || {}).constructor) && !Object.entries((obj || {})).length;

export const generateUUID = (digits = 8) => {
    const str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVXZ';
    const uuid = [];
    for (let i = 0; i < digits; i++) {
        uuid.push(str[Math.floor(Math.random() * str.length)]);
    }
    return uuid.join('');
};

export const has = (obj, key) => {
    const keyParts = key.split('.');

    return !!obj && (
        keyParts.length > 1
            ? has(obj[key.split('.')[0]], keyParts.slice(1).join('.'))
            : hasOwnProperty.call(obj, key)
    );
};

export const uniqBy = (arr, predicate) => {
    if (!Array.isArray(arr)) { return []; }

    const cb = typeof predicate === 'function' ? predicate : o => o[predicate];

    const pickedObjects = arr
        .filter(item => item)
        .reduce((map, item) => {
            const key = cb(item);

            if (!key) { return map; }

            return map.has(key) ? map : map.set(key, item);
        }, new Map())
        .values();

    return [...pickedObjects];
};

const isObject = item => (item && typeof item === 'object' && !Array.isArray(item));

export const mergeDeep = (target, ...sources) => {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach((key) => {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} });
                mergeDeep(target[key], source[key]);
            } else if (source[key] !== undefined) {
                Object.assign(target, { [key]: source[key] });
            }
        });
    }

    return mergeDeep(target, ...sources);
};

export const sortBy = key => (a, b) => {
    if (a[key] > b[key]) return 1;
    if ((b[key] > a[key])) return -1;
    return 0;
};
